import { captureError, SENTRY_SEVERITY, toApiError } from 'src/service/utils/sentry'
import { KTMVNOVerifySpace, TermsListSpace } from 'src/types/api'

type MissingField = 'Title' | 'Contents'

function captureMissingTerm(
  message: string,
  tags: { telecom: string; termKey: string; missing: MissingField },
) {
  captureError(toApiError(new Error(message)), {
    level: SENTRY_SEVERITY.Error,
    tags,
    fingerprint: ['terms-error', tags.telecom, tags.termKey, tags.missing],
  })
}

export function validateTermItem(
  telecom: string,
  termKey: string,
  term: TermsListSpace.TermItemsType,
) {
  const title = term.Title?.trim()
  const contents = term.Contents?.trim()

  if (!title) return // Title이 없으면 약관 미노출
  if (!contents) {
    captureMissingTerm(`[${telecom} : ${title}] Contents 누락`, {
      telecom,
      termKey,
      missing: 'Contents',
    })
  }
}

/** 가입 약관 검증 */
export function captureTermsError(response: TermsListSpace.Response | undefined) {
  if (!response) return

  Object.entries(response).forEach(([telecom, terms]) => {
    if (!terms || typeof terms !== 'object') return

    Object.entries(terms).forEach(([termKey, term]) => {
      if (typeof term !== 'object' || term === null || !('Required' in term)) return
      validateTermItem(telecom, termKey, term as TermsListSpace.TermItemsType)
    })
  })
}

/** KT MVNO 약관 검증 */
export function captureMvnoTermsError(body?: KTMVNOVerifySpace.Response) {
  // Type === 1(알뜰폰)일 때만 검증
  if (!body || body.Type !== 1) return

  const title = body.Title?.trim()
  const contents = body.Contents?.trim()

  if (!title) {
    captureMissingTerm('[KTTerms : MVNO] Title 누락', {
      telecom: 'KTTerms',
      termKey: 'MVNO',
      missing: 'Title',
    })
  }
  if (!contents) {
    captureMissingTerm('[KTTerms : MVNO] Contents 누락', {
      telecom: 'KTTerms',
      termKey: 'MVNO',
      missing: 'Contents',
    })
  }
}

/** 배너 이미지 검증 */
// export function captureBannerImagesError(src: string, imageId: string) {
//   captureError(toApiError(new Error(`[${imageId}] 이미지 로드 실패`)), {
//     level: SENTRY_SEVERITY.Error,
//     tags: { imageId },
//     extra: { src },
//     fingerprint: ['banner-image-error', imageId],
//   })
// }
